/* src/app/components/new-fund-modal/new-fund-modal.component.scss */
.modal-footer {
  padding-top: 4rem;
}
/*# sourceMappingURL=new-fund-modal.component.css.map */
